import { createApi } from '@reduxjs/toolkit/query/react';
import { NATIONALITY_ID_SHORT_CODE } from 'core';

import { axiosBaseQuery } from '../axiosBaseQuery';

export interface IdTypeResponse {
  Id: number;
  Name: string;
  ShortCode: string;
}

export interface IdType {
  id: string;
  name: string;
  shortCode: string;
  mustHaveExpiryDate: boolean;
}

export const idTypesApi = createApi({
  reducerPath: 'idTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/web-api/api',
  }),
  endpoints: (builder) => ({
    getIdTypesByCountry: builder.query<IdType[], number | string>({
      query: (countryId) => ({
        url: `/account/getIdTypesByCountryId?countryId=${countryId}`,
        method: 'get',
      }),
      transformResponse: (options: IdTypeResponse[]) =>
        options.map((option) => ({
          id: option.Id.toString(),
          name: option.Name,
          shortCode: option.ShortCode,
          mustHaveExpiryDate: option.ShortCode !== NATIONALITY_ID_SHORT_CODE,
        })),
    }),
  }),
});

export const { useGetIdTypesByCountryQuery } = idTypesApi;
